import { Box, Card, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import _debounce from 'lodash/debounce';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IOSSwitch } from '../../../shared/components/IOSSwitch';
import { EModules } from '../../../shared/enums/modules/EModules';
import { ETheme } from '../../../shared/enums/user/ETheme';
import { handleError } from '../../../shared/functions/handleError';
import { IUser } from '../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../shared/mui/palettes';
import moduleSlice from '../../../store/slices/module.slice';
import { RootState } from '../../../store/store';
import { DeveloperModuleService } from './service';

const DeveloperModules = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { list: modules, filters } = useSelector(
    (state: RootState) => state.module,
  );
  const { userData } = useSelector((state: RootState) => state?.auth);
  const { theme } = userData as IUser;
  const handleUpdateModule = async (moduleName: EModules) => {
    await DeveloperModuleService.update(moduleName)
      .then((response) => {
        enqueueSnackbar(
          t('toasts.successfullyUpdated', {
            title: t(`modules.${response?.name}`),
          }),
          { variant: 'success' },
        );
        dispatch(
          moduleSlice.actions.setModules(
            modules.map((module) =>
              module.id === response?.id ? response : module,
            ),
          ),
        );
      })
      .catch(handleError);
  };

  return (
    <Card>
      <TextField
        onChange={_debounce((e) => {
          dispatch(
            moduleSlice.actions.setModuleFilters({ name: e.target.value }),
          );
        }, 300)}
        label={t('general.searchByName')}
        defaultValue={filters?.name}
        sx={{
          width: {
            xs: '100%',
            md: '50%',
          },
        }}
      />
      <Grid container spacing={2}>
        {modules?.map((module, index) => {
          return (
            <Grid
              size={{
                xs: 12,
                md: 6,
                lg: 4,
              }}
              key={module?.id}
            >
              <Box
                sx={{
                  paddingTop: '20px',
                  paddingBottom: '20px',
                  borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography>{t(`modules.${module?.name}`)}</Typography>
                    <Typography
                      variant={'subtitle2'}
                      color={lightPalette.text.gray}
                      sx={{
                        fontWeight: '300',
                      }}
                    >
                      {t(`modules.${module?.name}_desc`)}
                    </Typography>
                  </Box>
                  <div>
                    <IOSSwitch
                      checked={module?.isEnabled}
                      onChange={async () => {
                        await handleUpdateModule(module?.name);
                      }}
                    />
                  </div>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Card>
  );
};

export default DeveloperModules;
